import { AirwallexIntent } from '@40seas/entities/airwallex';
import { Pick } from '@40seas/entities/common';

export class CreateAirwallexIntentDto extends Pick(AirwallexIntent, ['checkout', 'amount', 'currency', 'buyer']) {}
